import axios from "axios";

export const iwmsPost = (url, reqData, additionalHeaders = {}) => {
  return new Promise((resolve, reject) => {
    axios({
      method: "POST",
      url,
      data: reqData,
      headers: {
        //Authorization: `Bearer ${process.env.SERVER_TOKEN}`,
        "Content-Type": "application/json",
        Accept: "application/json",
        ...additionalHeaders,
      },
    })
      .then((response) => {
        resolve({
          status: true,
          data: response.data,
          statusCode: response.status,
        });
      })
      .catch((err) => {
        console.error("Error in POST request:", err);
        const { response } = err;
        const message = `Error: ${response?.status} - ${response?.data?.message || JSON.stringify(response?.data) || err.message || 'An unknown error occurred - iwmsPost'} `;

        reject({
          status: false,
          message,
        });
      });
  });
};

// Improved get function with async/await and better error handling
export const iwmsGet = (url, reqData = {}, additionalHeaders = {}) => {
  return new Promise((resolve, reject) => {
    axios({
      method: "GET",
      url,
      params: reqData, // Use params for GET request data
      headers: {
        //Authorization: `Bearer ${process.env.SERVER_TOKEN}`,
        "Content-Type": "application/json",
        Accept: "application/json",
        ...additionalHeaders,
      },
    })
      .then((response) => {
        resolve({
          status: true,
          data: response.data,
        });
      })
      .catch((err) => {
        console.error("Error in GET request:", err);
        const { response } = err;
        const message = `Error: ${response?.status} - ${response?.data?.message || JSON.stringify(response?.data) || err.message || 'An unknown error occurred - iwmsGet'} `;

        reject({
          status: false,
          message,
        });
      });
  });
};
